import { Helmet } from 'react-helmet';

import type { MetaData } from './meta';

export const MetaTag = ({ title, description, absoluteUrl }: MetaData) => (
  <Helmet>
    {title && <title>{title}</title>}
    {description && <meta name="description" content={description} />}
    {absoluteUrl && <link rel="canonical" href={absoluteUrl} />}
  </Helmet>
);
